import {
    GET_PROVISION_STATUS_DEF_SUCCESS,
    PROVISION_STATUS_DEF_API_ERROR
} from "./actionTypes"

const INIT_STATE = {
    recordList: [], //Model Data ve Error
    error: {},
}

const provisionStatusDef = (state = INIT_STATE, action) => {
    switch (action.type) {

        case GET_PROVISION_STATUS_DEF_SUCCESS:
            return {
                ...state,
                recordList: action.payload,
            }

        case PROVISION_STATUS_DEF_API_ERROR:
            return {
                ...state,
                error: action.payload,
            }

        default:
            return state
    }
}

export default provisionStatusDef